import React, { useState } from "react";
import "./helpdesk.css";
import Header from "../../Components/Header";
import { ChevronDown, ChevronUp } from "lucide-react";

const HelpDesk = () => {
  const [visibleSection, setVisibleSection] = useState("");
  const [openSection, setOpenSection] = useState(5);

  const showSection = (sectionId) => {
    setVisibleSection(sectionId); // Set the clicked section as visible
  };

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  return (
    <>
      {/* Hero Section */}
      <Header heading="Help Desk" />
      <div
        className="hero"
        style={{
          background: 'url("assets/images/desk.jpg")',
          height: "20rem",
          width: "100%",
        }}
      >
        <h1 className="mt-2 text-blue-500">
          H<span className="text-yellow-500">e</span>lpd
          <span className="text-yellow-600">e</span>sk
        </h1>
        <p>Dashboard / Helpdesk</p>
        <div className="search-bar">
          <input
            type="text"
            placeholder="Search here"
            className="form-control inline-block ml-16 shadow-inner border border-blue-600"
            style={{
              borderColor: "rgb(15, 15, 242)",
              boxShadow:
                "inset 0px 35px 25px #dddee1e0, inset 10px 0px 25px #0000004b, inset 40px 0px 20px #fff, inset -10px 0px 25px #0000004b, inset -40px 0px 20px #cbced7, inset 0px 10px 10px #000000e0, inset 0px -15px 25px #00000036, 10px 25px 40px -10px #00000060",
            }}
          />
          <button className="bg-blue-800 rounded-md text-white hover:text-black hover:bg-blue-500 py-2 px-3">
            Search
          </button>
        </div>
      </div>
      {/* Content Section */}
      <div className="container mx-auto ">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
          <div className="p-3 shadow-xl shadow-slate-400 rounded-xl">
            <h5>
              <button
                className="underline font-bold text-blue-700 text-xl"
                onClick={() => showSection("firstcontainer")}
              >
                Getting Started FAQs
              </button>
            </h5>
            <p className="p-4">(Frequently Asked Questions)</p>
          </div>
          <div className="p-3 shadow-xl shadow-slate-400 rounded-xl">
            <h5>
              <button
                className="underline font-bold text-blue-700 text-xl"
                onClick={() => showSection("secondcontainer")}
              >
                User Account Terms
              </button>
            </h5>
            <p className="p-4">Terms and Conditions agreement</p>
          </div>
          <div className="p-3 shadow-xl shadow-slate-400 rounded-xl">
            <h5>
              <button
                className="underline font-bold text-blue-700 text-xl"
                onClick={() => showSection("thirdcontainer")}
              >
                Product Features Support
              </button>
            </h5>
          </div>
        </div>

        {/* Sections to be shown/hidden */}

        {/* Sections to be shown based on state */}
        {visibleSection === "firstcontainer" && (
          <div className="mt-4">
            <div className="accordion">
              {/* faq starts here */}

              <div className="border border-gray-200 rounded">
                <h2 className="accordion-header">
                  <button
                    className="w-full flex items-center justify-between text-left bg-blue-500 text-white px-4 py-2 rounded-t focus:outline-none"
                    onClick={() => toggleSection(5)}
                  >
                    <h5>What is IDSPay API?</h5>
                    {openSection === 5 ? <ChevronUp /> : <ChevronDown />}
                  </button>
                </h2>
                {openSection === 5 && (
                  <div className="accordion-collapse">
                    <div className="accordion-body p-4 bg-gray-100">
                      <p>
                        IDSPay API is a secure fintech API platform that allows
                        businesses to integrate financial, banking, KYC, and
                        verification services into their applications through
                        simple REST APIs. It helps automate processes like
                        identity verification, payment validation, and
                        compliance checks
                      </p>
                    </div>
                  </div>
                )}
              </div>

              {/* FAQs #3 */}
              <div className="border border-gray-200 rounded">
                <h2 className="accordion-header">
                  <button
                    className="w-full text-left flex items-center justify-between bg-blue-500 text-white px-4 py-2 rounded-t focus:outline-none"
                    onClick={() => toggleSection(3)}
                  >
                    <h5>Is digital KYC is mandatory before using the API?</h5>
                    {openSection === 3 ? <ChevronUp /> : <ChevronDown />}
                  </button>
                </h2>
                {openSection === 3 && (
                  <div className="accordion-collapse">
                    <div className="accordion-body p-4 bg-gray-100">
                      <p>
                        Yes, As per the new update from the regulatory Digital
                        KYC is required before accessing the API Services.{" "}
                        <br />
                        👉 <strong>Reason :</strong> RBI & NPCI regulations
                        require only verified entities to use such APIs because
                        they access financial/personal data.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div className="border border-gray-200 rounded">
                <h2 className="accordion-header">
                  <button
                    className="w-full text-left flex items-center justify-between bg-blue-500 text-white px-4 py-2 rounded-t focus:outline-none"
                    onClick={() => toggleSection(4)}
                  >
                    <h5>How can I add the balance in API wallet?</h5>
                    {openSection === 4 ? <ChevronUp /> : <ChevronDown />}
                  </button>
                </h2>
                {openSection === 4 && (
                  <div className="accordion-collapse">
                    <div className="accordion-body p-4 bg-gray-100">
                      <p>
                        You can add the balance in API by using UPI QR & Bank
                        Transfer Methods, Be Careful we will not adjust or
                        settle back or refund your API wallet balance once you
                        added, so add a limited or required amount to API
                        wallet. If you have added balance in API Wallet means
                        you have to use the service only.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div className="border border-gray-200 rounded">
                <h2 className="accordion-header">
                  <button
                    className="w-full text-left flex items-center justify-between bg-blue-500 text-white px-4 py-2 rounded-t focus:outline-none"
                    onClick={() => toggleSection(6)}
                  >
                    <h5>Which services are available through IDSPay APIs?</h5>
                    {openSection === 6 ? <ChevronUp /> : <ChevronDown />}
                  </button>
                </h2>
                {openSection === 6 && (
                  <div className="accordion-collapse">
                    <div className="accordion-body p-4 bg-gray-100">
                      <p>
                        IDSPay offers a wide range of APIs including PAN
                        verification, bank account verification, IFSC
                        validation, AEPS services, UPI APIs, auto-debit
                        solutions, wallet services, and other utility APIs
                        required by fintech and enterprise businesses.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div className="border border-gray-200 rounded">
                <h2 className="accordion-header">
                  <button
                    className="w-full text-left flex items-center justify-between bg-blue-500 text-white px-4 py-2 rounded-t focus:outline-none"
                    onClick={() => toggleSection(7)}
                  >
                    <h5>Who is eligible to use IDSPay APIs? Answer:</h5>
                    {openSection === 7 ? <ChevronUp /> : <ChevronDown />}
                  </button>
                </h2>
                {openSection === 7 && (
                  <div className="accordion-collapse">
                    <div className="accordion-body p-4 bg-gray-100">
                      <p>
                        IDSPay APIs are designed for fintech companies,
                        startups, NBFCs, software companies, aggregators,
                        merchants, and enterprises. All users must complete
                        mandatory onboarding and compliance verification before
                        live API access is granted.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div className="border border-gray-200 rounded">
                <h2 className="accordion-header">
                  <button
                    className="w-full text-left flex items-center justify-between bg-blue-500 text-white px-4 py-2 rounded-t focus:outline-none"
                    onClick={() => toggleSection(8)}
                  >
                    <h5>How secure are IDSPay APIs?</h5>
                    {openSection === 8 ? <ChevronUp /> : <ChevronDown />}
                  </button>
                </h2>
                {openSection === 8 && (
                  <div className="accordion-collapse">
                    <div className="accordion-body p-4 bg-gray-100">
                      <p>
                        IDSPay APIs follow industry-standard security protocols
                        including encrypted communication, secure API
                        authentication, and controlled access mechanisms. This
                        ensures complete data privacy, transaction safety, and
                        protection against unauthorized access.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div className="border border-gray-200 rounded">
                <h2 className="accordion-header">
                  <button
                    className="w-full text-left flex items-center justify-between bg-blue-500 text-white px-4 py-2 rounded-t focus:outline-none"
                    onClick={() => toggleSection(9)}
                  >
                    <h5>HHow can I get IDSPay API access?</h5>
                    {openSection === 9 ? <ChevronUp /> : <ChevronDown />}
                  </button>
                </h2>
                {openSection === 9 && (
                  <div className="accordion-collapse">
                    <div className="accordion-body p-4 bg-gray-100">
                      <p>
                        To access IDSPay APIs, you need to create an account,
                        submit required KYC and business documents, and request
                        the desired API services. Once approved, API keys and
                        documentation are shared for integration.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div className="border border-gray-200 rounded">
                <h2 className="accordion-header">
                  <button
                    className="w-full text-left flex items-center justify-between bg-blue-500 text-white px-4 py-2 rounded-t focus:outline-none"
                    onClick={() => toggleSection(10)}
                  >
                    <h5>How long does IDSPay API activation take?</h5>
                    {openSection === 10 ? <ChevronUp /> : <ChevronDown />}
                  </button>
                </h2>
                {openSection === 10 && (
                  <div className="accordion-collapse">
                    <div className="accordion-body p-4 bg-gray-100">
                      <p>
                        API activation usually takes 24 to 72 working hours,
                        depending on document verification, compliance approval,
                        and the selected API modules. In some cases, activation
                        may be faster for pre-verified businesses.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div className="border border-gray-200 rounded">
                <h2 className="accordion-header">
                  <button
                    className="w-full text-left flex items-center justify-between bg-blue-500 text-white px-4 py-2 rounded-t focus:outline-none"
                    onClick={() => toggleSection(11)}
                  >
                    <h5>Is there a sandbox or test environment available?</h5>
                    {openSection === 11 ? <ChevronUp /> : <ChevronDown />}
                  </button>
                </h2>
                {openSection === 11 && (
                  <div className="accordion-collapse">
                    <div className="accordion-body p-4 bg-gray-100">
                      <p>
                        Yes, IDSPay provides a sandbox or test environment that
                        allows developers to test API integration, responses,
                        and error handling before moving to the production
                        environment.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div className="border border-gray-200 rounded">
                <h2 className="accordion-header">
                  <button
                    className="w-full text-left flex items-center justify-between bg-blue-500 text-white px-4 py-2 rounded-t focus:outline-none"
                    onClick={() => toggleSection(12)}
                  >
                    <h5>What pricing model does IDSPay follow?</h5>
                    {openSection === 12 ? <ChevronUp /> : <ChevronDown />}
                  </button>
                </h2>
                {openSection === 12 && (
                  <div className="accordion-collapse">
                    <div className="accordion-body p-4 bg-gray-100">
                      <p>
                        IDSPay follows a transparent, usage-based pricing model
                        where businesses are charged per API hit or transaction.
                        Pricing varies depending on the API type, volume, and
                        service category.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div className="border border-gray-200 rounded">
                <h2 className="accordion-header">
                  <button
                    className="w-full text-left flex items-center justify-between bg-blue-500 text-white px-4 py-2 rounded-t focus:outline-none"
                    onClick={() => toggleSection(13)}
                  >
                    <h5>Does IDSPay provide technical support?</h5>
                    {openSection === 13 ? <ChevronUp /> : <ChevronDown />}
                  </button>
                </h2>
                {openSection === 13 && (
                  <div className="accordion-collapse">
                    <div className="accordion-body p-4 bg-gray-100">
                      <p>
                        Yes, IDSPay offers dedicated technical support, complete
                        API documentation, and integration assistance. Support
                        is available during onboarding, testing, and
                        post-deployment to ensure smooth operations.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div className="border border-gray-200 rounded">
                <h2 className="accordion-header">
                  <button
                    className="w-full text-left flex items-center justify-between bg-blue-500 text-white px-4 py-2 rounded-t focus:outline-none"
                    onClick={() => toggleSection(14)}
                  >
                    <h5>
                      Can IDSPay APIs be customized as per business needs?
                    </h5>
                    {openSection === 14 ? <ChevronUp /> : <ChevronDown />}
                  </button>
                </h2>
                {openSection === 14 && (
                  <div className="accordion-collapse">
                    <div className="accordion-body p-4 bg-gray-100">
                      <p>
                        Yes, IDSPay APIs can be customized based on specific
                        business requirements, transaction volumes, and use
                        cases. Custom pricing, API responses, and service
                        configurations may be offered subject to feasibility and
                        compliance.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              {/* More FAQs */}
            </div>
          </div>
        )}

        {/* {visibleSection === 'secondcontainer' && (
          <div className="mt-4">
            <div className="p-12 shadow-inner">
              <h2 className="text-center text-blue-500 underline">
                User Account Terms
              </h2>
              <div>
                <h5>termsphrase [ plural ]Add to word list B2</h5>
                 {openSection === 5 ?
                  <ChevronUp/> : <ChevronDown/>
                  }
                <div>
                  <span className="text-blue-500">*</span> the conditions that
                  control an agreement, arrangement, or activity:
                </div>
                <hr />
                <div>
                  <span className="text-blue-500">*</span> terms and conditions This
                  competition is only open to UK residents. Terms and conditions may
                  apply.:
                </div>
                <hr />
                <div>
                  <span className="text-blue-500">*</span> the conditions that control
                  an agreement, arrangement, or activity:
                </div>
                <hr />
                <div>
                  <span className="text-blue-500">*</span> terms of She broke her
                  terms of employment by leaving without giving notice.:
                </div>
                <hr />
                <div>
                  <span className="text-blue-500">*</span> They are claiming that he
                  broke the terms of a confidentiality agreement that he signed with
                  the couple.:
                </div>
                <hr />
                <div>
                  <span className="text-blue-500">*</span> They had agreed to the
                  terms of the previous contract.:
                </div>
                <hr />
                <div>
                  <span className="text-blue-500">*</span> We will then be in a better
                  position to dictate the terms of the sale.:
                </div>
              </div>
            </div>
          </div>
        )} */}

        {visibleSection === "thirdcontainer" && (
          <div className="text-center">
            <div className="shadow-inner">
              <h5>Product Features Support</h5>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="shadow-xl shadow-slate-400 rounded-xl p-4">
                <div className="card-body">
                  <h5 className="text-blue-600 underline font-semibold text-lg mb-3">
                    Discuss For New Projects or API’s
                  </h5>
                  <div className="contact-info">
                    <p>
                      <strong className="text-purple-700">Call To</strong> +91-
                      91137 22202
                    </p>
                    <p>
                      <strong className="text-purple-700">Call To</strong> +91
                      91539 88494
                    </p>
                    <p>
                      <strong className="text-purple-700">Email ID</strong>{" "}
                      Sales@idspay.in
                    </p>
                    <span className="text-dark text-xs">
                      *Customer can only discuss on WhatsApp/Email belonging
                      from Nepal & Bhutan.
                    </span>
                  </div>
                  <hr className="my-4" />
                  {/* <h5 className="text-blue-600 underline font-semibold text-lg mb-3">
                    Discuss For New Projects
                  </h5>
                  <div className="contact-info">
                    <p>
                      <strong className="text-purple-700">IND</strong> - +91-
                      91539 88494
                    </p>
                    <p>
                      <strong className="text-purple-700">Email ID</strong> -
                      Sales@idspay.in
                    </p>
                  </div>
                  <hr className="my-4" />
                  <h5 className="text-blue-600 underline font-semibold text-lg mb-3">
                    Planning to Visit Office?
                  </h5>
                  <p>
                    <strong className="text-purple-700">Address</strong> - First
                    Floor, Pathak House, B-Block, Brahampura, Muzaffarpur-
                    842001
                  </p> */}
                </div>
              </div>

              <div className=" shadow-xl shadow-slate-400 rounded-xl p-4">
                <div className="card-body">
                  <h5 className="text-blue-600 underline font-semibold text-lg mb-3">
                    API Support Department
                  </h5>
                  <div className="contact-info">
                    <p>
                      <strong className="text-purple-700">IND</strong> +91-
                      86036 93666
                    </p>
                    <p>
                      <strong className="text-purple-700">IND</strong> +91-
                      77820 05449
                    </p>
                    <p>
                      <strong className="text-purple-700">Email ID</strong>{" "}
                      support@idspay.in
                    </p>
                    <span className="text-dark text-xs">
                      *only WhatsApp/Email/Ticket System/Google Meet support
                      will be available for Nepal & Bhutan client’s
                    </span>
                  </div>
                  <hr className="my-4" />
                  {/* <h5 className="text-blue-600 underline font-semibold text-lg mb-3">
                    Accounts Department
                  </h5>
                  <p>
                    <strong className="text-purple-700">Email ID</strong> -
                    accounts@infocartgroup.com
                  </p>
                  <hr className="my-4" />
                  <h5 className="text-blue-600 underline font-semibold text-lg mb-3">
                    HR Department
                  </h5>
                  <div className="contact-info">
                    <p>
                      <strong className="text-purple-700">IND</strong> - +91-
                      91137 22202
                    </p>
                    <p>
                      <strong className="text-purple-700">IND</strong> - +91-
                      86036 93666
                    </p>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default HelpDesk;
